import {
  Button,
  Collapse,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { useConfig } from '../../../hooks/useConfig';
import useDestinations from '../../../hooks/useDestinations';
import useModal from '../../../hooks/useModal';
import Link from '../../../inmarkit/Link';
import DestinationsForm from './DestinationsForm';

function DestinationsTable() {
  const conquest = useWatch({ name: 'conquest' });
  const { apiHost } = useConfig();

  const { getValues } = useFormContext();
  const [adGroupId, adGroupName, lineItemId] = getValues(['id', 'name', 'insertionOrderId']);
  const headCells = ['Name', 'Latitude', 'Longitude', 'Address'];
  const { data, isLoading, isSuccess, page, perPage, setPage, setPerPage } = useDestinations(adGroupId, conquest);

  const handlePageChange = (_event: unknown, value: number) => {
    setPage(value);
  };

  const handlePerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPerPage(Number(event.target.value));
    setPage(0);
  };

  const [showDestinationsForm, closeDestinationsForm] = useModal(() => (
    <DestinationsForm
      adGroupId={adGroupId}
      adGroupName={adGroupName}
      lineItemId={lineItemId}
      onClose={closeDestinationsForm}
    />
  ));

  return (
    <Stack spacing={2}>
      <Collapse in={conquest} timeout="auto" unmountOnExit={false}>
        <Stack spacing={2}>
          <Typography>Destinations List</Typography>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Stack>
              <Stack direction="row" spacing={2} justifyContent="end">
                <Link target="_blank" href={`${apiHost}/admin/campaigns/${adGroupId}/destinations/index_csv`} pt={1}>
                  Download (CSV)
                </Link>
                <Button onClick={showDestinationsForm}>Update</Button>
              </Stack>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {headCells.map((headCell) => (
                        <TableCell key={headCell} align="left">
                          <Typography>{headCell}</Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {isLoading &&
                      Array.from({ length: 4 }, () => Math.random()).map((rowItem) => (
                        <TableRow key={rowItem} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          {Array.from({ length: 15 }, () => Math.random()).map((colItem) => (
                            <TableCell key={colItem} scope="row">
                              <Skeleton animation="wave" variant="text" sx={{ fontSize: '1rem' }} />
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    {isSuccess &&
                      data.collection?.map((destination) => (
                        <TableRow key={destination.id}>
                          <TableCell>{destination.name}</TableCell>
                          <TableCell>{destination.latitude}</TableCell>
                          <TableCell>{destination.longitude}</TableCell>
                          <TableCell>{destination.address}</TableCell>
                        </TableRow>
                      ))}
                    {isSuccess && (
                      <TableRow key="locations-pagination">
                        <TablePagination
                          rowsPerPageOptions={[10, 25, 50, 100, 200, 500]}
                          count={data.pagination?.totalItems || 0}
                          page={page}
                          onPageChange={handlePageChange}
                          rowsPerPage={perPage}
                          onRowsPerPageChange={handlePerPageChange}
                        />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Stack>
          </Paper>
        </Stack>
      </Collapse>
    </Stack>
  );
}

export default DestinationsTable;
